import { BeckyModel, ComponentsNativeMappers, NativeExtension } from '@wix/thunderbolt-becky-root'
import _ from 'lodash'
import * as AddressInput from './components/AddressInput/AddressInput.mapper'
import * as AdminLoginButton from './components/AdminLoginButton/AdminLoginButton.mapper'
import * as AppPart from './components/AppPart/AppPart.mapper'
import * as AppPart2 from './components/AppPart/AppPart2.mapper'
import * as AppWidget from './components/AppWidget/AppWidget.mapper'
import * as BackgroundGroup from './components/BackgroundGroup/BackgroundGroup.mapper'
import * as BackToTopButton from './components/BackToTopButton/BackToTopButton.mapper'
import * as Checkbox from './components/Checkbox/Checkbox.mapper'
import * as CheckboxGroup from './components/CheckboxGroup/CheckboxGroup.mapper'
import * as ClassicSection from './components/ClassicSection/ClassicSection.mapper'
import { designCss as SectionDesignCss, css as SectionCss } from './components/Section/Section.mapper'
import * as ComboBoxInput from './components/ComboBoxInput/ComboBoxInput.mapper'
import * as ComboBoxInputListModal from './components/ComboBoxInput/ComboBoxInputListModal.mapper'
import * as Container from './components/Container/Container.mapper'
import * as DatePicker from './components/DatePicker/DatePicker.mapper'
import * as DropDownMenu from './components/DropDownMenu/DropDownMenu.mapper'
import * as ExpandableMenu from './components/ExpandableMenu/ExpandableMenu.mapper'
import * as FacebookLikeBox from './components/FacebookLikeBox/FacebookLikeBox.mapper'
import * as FileUploader from './components/FileUploader/FileUploader.mapper'
import * as FiveGridLine from './components/FiveGridLine/FiveGridLine.mapper'
import * as FooterContainer from './components/FooterContainer/FooterContainer.mapper'
import * as HeaderContainer from './components/HeaderContainer/HeaderContainer.mapper'
import { css as HeaderSectionCss } from './components/HeaderSection/HeaderSection.mapper'
import * as ItunesButton from './components/ItunesButton/ItunesButton.mapper'
import * as LanguageSelector from './components/LanguageSelector/LanguageSelector.mapper'
import * as LinkBar from './components/LinkBar/LinkBar.mapper'
import * as LoginSocialBar from './components/LoginSocialBar/LoginSocialBar.mapper'
import * as MediaContainer from './components/MediaContainer/MediaContainer.mapper'
import * as MenuContainer from './components/MenuContainer/MenuContainer.mapper'
import * as MenuToggle from './components/MenuToggle/MenuToggle.mapper'
import * as Page from './components/Page/Page.mapper'
import * as PageGroup from './components/PageGroup/PageGroup.mapper'
import * as PaginatedGridGallery from './components/PaginatedGridGallery/PaginatedGridGallery.mapper'
import * as Pagination from './components/Pagination/Pagination.mapper'
import * as PopupCloseIconButton from './components/PopupCloseIconButton/PopupCloseIconButton.mapper'
import * as QuickActionBar from './components/QuickActionBar/QuickActionBar.mapper'
import * as RadioGroup from './components/RadioGroup/RadioGroup.mapper'
import * as RatingsDisplay from './components/RatingsDisplay/RatingsDisplay.mapper'
import * as RatingsInput from './components/RatingsInput/RatingsInput.mapper'
import * as RefComponent from './components/RefComponent/RefComponent.mapper'
import * as ResponsivePopupPage from './components/ResponsivePopupPage/ResponsivePopupPage.mapper'
import * as RichTextBox from './components/RichTextBox/RichTextBox.mapper'
import * as ScreenWidthContainer from './components/ScreenWidthContainer/ScreenWidthContainer.mapper'
import * as SearchBox from './components/SearchBox/SearchBox.mapper'
import * as SelectableContainer from './components/SelectableContainer/SelectableContainer.mapper'
import * as SelectionTagsList from './components/SelectionTagsList/SelectionTagsList.mapper'
import * as SignatureInput from './components/SignatureInput/SignatureInput.mapper'
import * as SiteButton from './components/SiteButton/SiteButton.mapper'
import * as SkypeCallButton from './components/SkypeCallButton/SkypeCallButton.mapper'
import * as SlideShowSlide from './components/SlideShowSlide/SlideShowSlide.mapper'
import * as StripColumnsContainer from './components/StripColumnsContainer/StripColumnsContainer.mapper'
import * as Column from './components/StripColumnsContainer/Column.mapper'
import * as TextAreaInput from './components/TextAreaInput/TextAreaInput.mapper'
import * as TextInput from './components/TextInput/TextInput.mapper'
import * as TimePicker from './components/TimePicker/TimePicker.mapper'
import * as TinyMenu from './components/TinyMenu/TinyMenu.mapper'
import * as VerticalMenu from './components/VerticalMenu/VerticalMenu.mapper'
import * as VectorImage from './components/VectorImage/VectorImage.mapper'
import * as WPhoto from './components/WPhoto/WPhoto.mapper'
import * as VideoBox from './components/VideoBox/VideoBox.mapper'
import * as WFacebookComment from './components/WFacebookComment/WFacebookComment.mapper'
import { selectorToCss as WRichTextSelectorToCss, css as WRichTextCss } from './components/WRichText/WRichText.mapper'
import * as PopupContainer from './components/PopupContainer/PopupContainer.mapper'
import * as PopupPage from './components/PopupPage/PopupPage.mapper'
import * as PageBackground from './components/PageBackground/PageBackground.mapper'
import * as TPAWidget from './components/TPAWidget/TPAWidget.mapper'
import * as HoverBox from './components/HoverBox/HoverBox.mapper'
import * as VideoBoxAudio from './components/VideoBox/VideoBoxAudio.mapper'
import * as VideoBoxPlay from './components/VideoBox/VideoBoxPlay.mapper'
import { withCompInfo } from '@wix/editor-elements-integrations'
import * as Repeater from './components/Repeater/Repeater.mapper'

export type MergeMappers = (
	mappers: ComponentsNativeMappers,
	isExperimentOpen: (name: keyof BeckyModel['experiments']) => boolean,
	mappersDenyList?: BeckyModel['mappersDenyList']
) => ComponentsNativeMappers

const emptyMapper = withCompInfo()([], () => {
	return {}
})
const getCatharsisMappers = (isExperimentOpen: (name: keyof BeckyModel['experiments']) => boolean) => {
	const compCssMappersCatharsis = isExperimentOpen('specs.thunderbolt.compCssMappers_catharsis')
	const isCompDesignCssAndSelectorToCssMappersCatharsisOpen =
		compCssMappersCatharsis && isExperimentOpen('specs.thunderbolt.comp_designCss_selectorToCss_Mappers_catharsis')

	const WRichText = {
		...{ css: WRichTextCss },
		...(isCompDesignCssAndSelectorToCssMappersCatharsisOpen && { selectorToCss: WRichTextSelectorToCss }),
	}

	const Section = {
		css: SectionCss,
		...(isCompDesignCssAndSelectorToCssMappersCatharsisOpen && { designCss: SectionDesignCss }),
	}

	const HeaderSection = {
		css: HeaderSectionCss,
		...(isCompDesignCssAndSelectorToCssMappersCatharsisOpen && { designCss: SectionDesignCss }),
	}

	return {
		AppPart,
		AppPart2,
		AddressInput,
		AdminLoginButton,
		AppWidget,
		BackgroundGroup,
		BackToTopButton,
		Checkbox,
		CheckboxGroup,
		ComboBoxInput,
		ComboBoxInputListModal,
		DatePicker,
		FacebookLikeBox,
		FileUploader,
		FiveGridLine,
		FooterSection: Section,
		ItunesButton,
		LanguageSelector,
		LinkBar,
		LoginSocialBar,
		PaginatedGridGallery,
		Pagination,
		PopupCloseIconButton,
		RadioGroup,
		RatingsDisplay,
		RatingsInput,
		SignatureInput,
		SiteButton,
		WFacebookComment,
		TextAreaInput,
		TextInput,
		TimePicker,
		SkypeCallButton,
		SelectionTagsList,
		SearchBox,
		ScreenWidthContainer,
		RichTextBox,
		QuickActionBar,
		HeaderContainer,
		FooterContainer,
		ExpandableMenu,
		Container,
		DropDownMenu,
		HeaderSection,
		MenuContainer,
		Page,
		PageGroup,
		SlideShowSlide,
		TinyMenu,
		VerticalMenu,
		MenuToggle,
		PopupContainer,
		PopupPage,
		...(!compCssMappersCatharsis && { ResponsivePopupPage }),
		...(isExperimentOpen('specs.thunderbolt.MediaContainerAndPageBackgroundMapper') && {
			MediaContainer,
		}),
		...(compCssMappersCatharsis &&
			isExperimentOpen('specs.thunderbolt.MediaContainerAndPageBackgroundMapper') && {
				PageBackground,
			}),
		...(compCssMappersCatharsis &&
			isExperimentOpen('specs.thunderbolt.StripColumnsContainerMapper') && {
				StripColumnsContainer,
				ClassicSection,
				Column,
			}),
		...(compCssMappersCatharsis &&
			isExperimentOpen('specs.thunderbolt.refCompNativeMapper') && {
				RefComponent,
				SelectableContainer,
				Repeater,
			}),
		...(compCssMappersCatharsis &&
			isExperimentOpen('specs.thunderbolt.native_css_mappers_video') && {
				VectorImage,
				WPhoto,
				MediaControls: VideoBoxAudio,
				MediaOverlayControls: VideoBoxPlay,
				MediaPlayer: VideoBox,
			}),
		...(isCompDesignCssAndSelectorToCssMappersCatharsisOpen && { HoverBox }),
		...(!_.isEmpty(Section) && { Section }),
		...(compCssMappersCatharsis && {
			TPAWidget,
			TPAGluedWidget: TPAWidget,
			TPASection: TPAWidget,
			TPAMultiSection: TPAWidget,
			// Add empty mapper for preventing the carmi css mapper from running when it is already run by catharsis
			// Delete this along with the carmi css mapper once specs.thunderbolt.compCssMappers_catharsisis merged
			// In catharsis there is no structure mapper, so the css will be computed by TPAWidget.mapper.ts
			tpaWidgetNative: { css: emptyMapper },
		}),
		...(!_.isEmpty(WRichText) && { WRichText }),
	}
}

export const hasNativeOverrideMapper = (
	componentType: string,
	isExperimentOpen: (name: keyof BeckyModel['experiments']) => boolean
) => {
	const catharsisMappers = getCatharsisMappers(isExperimentOpen)
	return catharsisMappers.hasOwnProperty(componentType)
}

export const mergeMappers: MergeMappers = (mappers, isExperimentOpen, mappersDenyList = []) => {
	const catharsisMappers = _.omit(getCatharsisMappers(isExperimentOpen), mappersDenyList)
	return _.assignWith(
		{},
		mappers,
		catharsisMappers,
		(external: ComponentsNativeMappers[string], internal: ComponentsNativeMappers[string]) => {
			// If only EE or internal component definition (e.g. all mappers), return it
			if (!external || !internal) {
				return external || internal
			}

			return _.assignWith({}, external, internal, (ext, int) => {
				// If only EE or internal mapper exists, return it
				if (!ext || !int) {
					return ext || int
				}

				// If both internal and EE mapper exist, merge them
				const mapper: NativeExtension = {
					deps: { ...int.deps, ...ext.deps },
					resolver: (deps, carmiProps) => {
						// Calculate CARMI data using internal mapper, then pass it to the EE mapper
						const carmiData = int.resolver(deps, carmiProps)
						return ext.resolver(deps, carmiData)
					},
				}

				return mapper
			})
		}
	)
}
